import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface TwinPublishKeyType {
  publish: LocalesKey;
  unpublish: LocalesKey;
  publishAnyway: LocalesKey;
  cancel: LocalesKey;
  warningsTitle: LocalesKey;
  noWarnings: LocalesKey;
  confirmPublish: LocalesKey;
  preview: {
    plural: LocalesKey;
    variant: LocalesKey;
    slots: LocalesKey;
    zones: LocalesKey;
    allowedParts: LocalesKey;
    allowedMaterials: LocalesKey;
    default: LocalesKey;
    empty: LocalesKey;
    noVariants: LocalesKey;
    model: LocalesKey;
    noModel: LocalesKey;
    playerLoadFailed: LocalesKey;
    controlsTitle: LocalesKey;
    partsLoading: LocalesKey;
    partsFailed: LocalesKey;
    noControls: LocalesKey;
    noCandidatesForSlot: LocalesKey;
    options: LocalesKey;
  };
}

export const twinPublishKeys = keyPathMirror<TwinPublishKeyType, string>(
  {
    publish: null,
    unpublish: null,
    publishAnyway: null,
    cancel: null,
    warningsTitle: null,
    noWarnings: null,
    confirmPublish: null,
    preview: {
      plural: null,
      variant: null,
      slots: null,
      zones: null,
      allowedParts: null,
      allowedMaterials: null,
      default: null,
      empty: null,
      noVariants: null,
      model: null,
      noModel: null,
      playerLoadFailed: null,
      controlsTitle: null,
      partsLoading: null,
      partsFailed: null,
      noControls: null,
      noCandidatesForSlot: null,
      options: null
    }
  },
  'models.twinPublish.'
);
